import React from 'react';
import styled from 'styled-components';

import { ResourcesClientHome } from '@/components/common/resources';

const ResourceHomeRoute = (): React.ReactElement => {
  return (
    <Container>
      <ResourcesClientHome />
    </Container>
  );
};

export default ResourceHomeRoute;

const Container = styled.div`
  position: relative;
`;
